import { store } from "redux/store";
export function getToken() {
  if (store.getState().user.user?.token)
    return store.getState().user.user.token;
  else return store.getState().csrUser.csrUser.token;
}
